import { Controller } from '@hotwired/stimulus'
import _ from 'lodash'
import { showModal, hideModal } from '../../helpers/modals'
import { flashEffect } from 'helpers/effects'

export default class extends Controller {
  loader;
  connect() {
    this.loader = document.querySelector('.page-loader');
  }

  close(event) {
    event.preventDefault()
    const box = event.currentTarget.closest('.modal-content-wrapper')
    const boxId = box.id
    this.hide(boxId);
    if (box) {
      const frameId = box.dataset.frameId;
      const frame = document.querySelector(`turbo-frame#${frameId}`);
      frame.src = '';
    }
  }

  show(event) {
    const controller = this
    let boxes = controller.element.querySelectorAll('.result-box')
    boxes.forEach((box) => {
      box.classList.remove('selected');
    });
    let box = event.currentTarget.closest('.result-box')
    const boxId = event.currentTarget.dataset['boxId']
    showModal(boxId)
    box.classList.add('selected')
  }

  hide(boxId) {
    hideModal(boxId)
  }

  setChangedMetaVariableToUrl(event) {
    let box = event.currentTarget.closest('.result-box')
    let getSuggestionLink = box.querySelector('a.concept-suggestion')
    let url = new URL(getSuggestionLink.getAttribute('href'))
    let searchParams = url.searchParams
    searchParams.set('meta_variable', event.currentTarget.value)
    url.search = searchParams.toString();
    let newUrl = url.toString();
    getSuggestionLink.href = newUrl;
  }

  setConcept(event) {
    let formGroup = event.currentTarget.closest('.modal-form')
    let radioButtonGroup = formGroup.querySelectorAll('[name^="concept"]')
    let checked = Array.from(radioButtonGroup).find(
      (radio) => radio.checked
    );
    if (_.isNil(checked)) {
      flashEffect(this, {
        message: 'Select one from the list or create a new Concept',
        wrapperClass: 'alert-error',
        icons: ['fa-solid', 'fa-triangle-exclamation']
      })
      return
    }
    let checkedValue = checked.value
    if (checkedValue == 'custom') {
      checkedValue = formGroup.querySelector('#new_concept').value
    }
    let selectedResultBox = this.element.querySelector('.result-box.selected')
    let conceptField = selectedResultBox.querySelector('[data-field-name="concept"]')

    if (!_.isEmpty(checkedValue)) {
      conceptField.value = checkedValue
      conceptField.dispatchEvent(new Event('change'))
      hideModal('modal_suggestions_dialog')
    }
  }

  selectCustomConcept(event) {
    let formGroup = event.currentTarget.closest('.form-group')
    let customConceptField = formGroup.querySelector('#concept_custom')
    customConceptField.checked = true;
  }
}
